module.exports = __webpack_public_path__ + "img/2.a87ac118.png";